import { render, staticRenderFns } from "./TableGroups.vue?vue&type=template&id=af994d5a"
import script from "./TableGroups.vue?vue&type=script&lang=js"
export * from "./TableGroups.vue?vue&type=script&lang=js"
import style0 from "./TableGroups.vue?vue&type=style&index=0&id=af994d5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports